import React from 'react';

/**
 * SLS-style “Connect with our team” / transformation block. Content from JSON (connectBlock).
 */
export default function SectionConnect({ content, onConnect, onViewWork }) {
  const block = content?.connectBlock || content || {};
  const headline = block.headline ?? '';
  const subtext = block.subtext ?? '';
  const ctaText = block.ctaText ?? "Let's talk";
  const ctaSecondary = block.ctaSecondary ?? '';

  if (!headline && !subtext) return null;

  return (
    <section className="py-16 sm:py-20 flex items-center justify-center" style={{ background: 'var(--jb-connect-bg)', borderTop: '1px solid var(--jb-connect-border)' }}>
      <div className="max-w-2xl mx-auto px-4 text-center relative">
        <div className="absolute inset-0 rounded-3xl opacity-50" style={{ background: 'radial-gradient(ellipse 60% 60% at 50% 0%, var(--jb-connect-glow) 0%, transparent 70%)' }} />
        <div className="relative">
          {headline && (
            <h2 className="font-display font-black text-2xl sm:text-3xl md:text-4xl text-text-hero mb-4 leading-tight tracking-tight">
              {headline}
            </h2>
          )}
          {subtext && (
            <p className="font-body text-text-body text-base sm:text-lg mb-8 leading-relaxed">
              {subtext}
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {ctaText && (
              <button
                type="button"
                onClick={() => onConnect && onConnect()}
                className="jb-cta px-8 py-3.5 rounded-xl bg-gradient-to-r from-cyan to-accent-green text-forest-bg font-body font-bold shadow-lg shadow-cyan/25 hover:opacity-90 transition"
              >
                {ctaText}
              </button>
            )}
            {ctaSecondary && onViewWork && (
              <button
                type="button"
                onClick={onViewWork}
                className="px-8 py-3.5 rounded-xl border-2 text-text-body font-body font-semibold hover:border-cyan hover:text-cyan transition"
                style={{ borderColor: 'var(--jb-border)' }}
              >
                {ctaSecondary}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
